import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import jsondata from "../../district.json";
import jsonconst from "../../constituency.json";
import jsonpar from "../../parliamnet_name.json";
import "react-h5-audio-player/lib/styles.css";
import jsonData from "../../district_constituency.json";

import {
  Select,
  Input,
  Button,
  Table,
  Menu,
  Pagination,
  DatePicker,
  Modal,
  Form,
  Popover,
  Spin,
  message,
  Popconfirm,
  Descriptions,
  Row,
  Col,
  Upload,
  Tabs,
  Card,
  Tag,
  Tooltip,
  Checkbox,
} from "antd";

import {
  FilterOutlined,
  CloseOutlined,
  MoreOutlined,
  ReloadOutlined,
  SearchOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  GlobalOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import "../QueryBuilder/QueryBuilder.css";
import { useForm } from "antd/es/form/Form";
import { useAuth } from "../AuthContext";
import AcknowledgmentModal from "../Acknowledgement/Acknowledgement";
const { Option } = Select;
const { Search } = Input;
const { confirm } = Modal;
const { TextArea } = Input;

const STATUS_MODAL_CATEGORY_OPTIONS = [
  { value: "feedback_type", label: "Feedback Type" },
  { value: "status", label: "Status" },
  { value: "remarks", label: "Remarks" },
  { value: "call_notes", label: "Call Notes" },
];

const STATE_OPTIONS = [
  { value: 1, label: "Andhra Pradesh" },
  { value: 2, label: "Telangana" },
];

const getByKey = (data, key) => data[key] || data[String(key)] || [];

const toId = (value) => {
  if (value == null || value === "") return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

const findDistrictIdByName = (name) => {
  if (!name) return null;
  for (const stateId of [1, 2]) {
    const match = getByKey(jsondata, stateId).find(
      (district) => district.district_name === name
    );
    if (match) return match.id;
  }
  return null;
};

const findStateIdForDistrict = (districtId) => {
  if (districtId == null) return null;
  for (const stateId of [1, 2]) {
    if (
      getByKey(jsondata, stateId).some((district) => district.id === districtId)
    ) {
      return stateId;
    }
  }
  return null;
};

const getStateName = (record) => {
  if (record?.state_name) return record.state_name;
  const stateId =
    toId(record?.state_id) ??
    findStateIdForDistrict(
      toId(record?.district_id) ?? findDistrictIdByName(record?.district_name)
    );
  return STATE_OPTIONS.find((state) => state.value === stateId)?.label || "";
};

const QueryBuilder = ({
  Headername,
  Rulesdata,
  Databyquery,
  id,
  title,
  updateadmin,
  adminbutton,
  bulkvolunteers,
  addPetitionbutton,
  addpetition,
  addsource,
  addcategory,
  addassigne,
  addsourcepet,
  addcategoryepet,
  addassigneepet,
  petitionmanagementactions,
  additem,
  additembtn,
}) => {
  const [fields, setFields] = useState([]);
  const [columns, setColumns] = useState([]);
  const [fieldOperators, setFieldOperators] = useState({});
  const [rules, setRules] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [fieldsMetadata, setFieldsMetadata] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [district, setDistrict] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);

  const [editedData, setEditedData] = useState(null);
  const [editedIndex, setEditedIndex] = useState(null);
  const [questionDashboardForm] = Form.useForm();

  const [questionsModal, setQuestionsModal] = useState(false);

  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);

  const [currentRules, setCurrentRules] = useState();

  const [showSearchInput, setShowSearchInput] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [editedDatasource, setEditedDatasource] = useState(null);
  const [updatesourcemodal, setUpdateSourceModal] = useState(false);
  const [form] = useForm();
  const [sourcedetails] = Form.useForm();
  const [categorydetails] = Form.useForm();
  const [updatecategorymodal, setUpdateCategoryModal] = useState(false);
  const [editedDatacategory, setEditedDatacategory] = useState(null);
  const [assigndetails] = Form.useForm();
  const [editedDataassign, setEditedDataassign] = useState(null);
  const [updateassignmodal, setUpdateAssignModal] = useState(false);

  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [viewRecord, setViewRecord] = useState(null);
  const [printModalVisible, setPrintModalVisible] = useState(false);
  const [acknowledgmentModalVisible, setAcknowledgmentModalVisible] =
    useState(false);
  const [acknowledgmentData, setAcknowledgmentData] = useState({});
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editDistricts] = useState([]);
  const [editConstituencies] = useState([]);
  const [editMandals] = useState([]);
  const [editSelectedState] = useState(null);
  const [editSelectedDistrict] = useState(null);
  const [editSelectedConstituency] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [statusModalValueOptions, setStatusModalValueOptions] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [currentId, setCurrentId] = useState(null);

  const [editstatusModalVisible, setEditstatusModalVisible] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [roles, setRoles] = useState([]);
  const [role, setRole] = useState("");
  const { userRole } = useAuth();
  const [assignees, setAssignees] = useState([]);
  const [notes, setNotes] = useState([]);
  const [editedNotes, setEditedNotes] = useState({});
  const [currentRecordId, setCurrentRecordId] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [isModalVisibleForm, setIsModalVisibleForm] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [valueOptions, setValueOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const categoryOptions = [
    { value: "select value", label: "select value" },
    { value: "Feedback_Type", label: "Feedback Type" },
  ];

  const handleCategoryChange = (value) => {
    if (value !== "select value") {
      setSelectedCategory(value);
      fetchValueOptions(value);
      setSelectedValue(null);
    } else {
      setSelectedCategory(null);
      setValueOptions([]);
    }
  };

  const fetchValueOptions = async (category) => {
    console.log("cat", category);
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_item_list?field_type=${category}`
      );
      if (response.ok) {
        const data = await response.json();
        const formattedData = data.map((item) => ({
          value: item.name,
          label: item.name,
        }));
        setValueOptions(formattedData);
      } else {
        message.error("Failed to fetch values for the selected category");
      }
    } catch (error) {
      console.error("Error fetching value options:", error);
      message.error("Error fetching value options");
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);
  const { TabPane } = Tabs;

  const fetchStatusModalValueOptions = async (fieldType) => {
    if (!fieldType || fieldType === "remarks") {
      setStatusModalValueOptions([]);
      return;
    }
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_item_list?field_type=${fieldType}`
      );
      if (!response.ok) {
        message.error("Failed to fetch values for the selected category");
        setStatusModalValueOptions([]);
        return;
      }
      const data = await response.json();
      const list = Array.isArray(data) ? data : [];
      setStatusModalValueOptions(
        list.map((item) => ({
          value: item.name,
          label: item.name,
        }))
      );
    } catch (error) {
      console.error("Error fetching status modal options:", error);
      message.error("Error fetching value options");
      setStatusModalValueOptions([]);
    }
  };

  const showEditModal = (rowData) => {
    setSelectedRowData(rowData);

    form.setFieldsValue({
      name: rowData.name,
      fieldType: rowData.field_type,
      short_code: rowData.short_code,
    });

    setIsModalVisibleForm(true);
  };
  // useEffect(() => {
  //   fetchDropdownOptions("status", setUpdateStatus);
  // }, []);

  const fetchDropdownOptions = async (fieldType, setOptions) => {
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_item_list?field_type=${fieldType}`
      );

      if (response.status === 200) {
        const data = await response.json();

        // Log the data to check if it's in the expected format
        console.log("Fetched data:", data);

        // Check if data is an array, otherwise set an empty array
        const formattedData = Array.isArray(data)
          ? data.map((item) => ({
              value: item.name || "", // Fallback if name is undefined
              label: item.name || "", // Fallback if name is undefined
            }))
          : []; // Fallback to empty array if data is not an array

        // Ensure we are setting an array
        setOptions(formattedData);
      } else {
        message.error("Failed to fetch options");
        setOptions([]); // Set an empty array on failure
      }
    } catch (error) {
      message.error("Error fetching options");
      console.error("Error:", error);
      setOptions([]); // Set an empty array on error
    }
  };

  const handleFormSubmit = async (values) => {
    try {
      // Construct the specific payload for the POST request
      const payload = {
        field_type: selectedRowData.field_type,
        name: values.name,
      };

      const response = await fetch(
        `/api/portal/pms/update_pms_item/${selectedRowData.seq_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        message.success("Data updated successfully!");
        setIsModalVisibleForm(false);
      } else {
        message.error("Failed to update data");
      }
    } catch (error) {
      message.error("Error updating data");
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (editstatusModalVisible) {
      form.resetFields();
      setStatusModalValueOptions([]);
    }
  }, [editstatusModalVisible]);

  useEffect(() => {
    if (editModalVisible) {
      fetchAssignees();
      fetchDepartments();
    }
  }, [editModalVisible]);

  const beforeUploadFile = (file) => {
    const isExcel =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel";

    if (!isExcel) {
      message.error("You can only upload Excel files!");
      return Upload.LIST_IGNORE;
    }

    // const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error("File must be smaller than 2MB!");
    //   return Upload.LIST_IGNORE;
    // }

    // If file is valid, set the file state and return false to prevent automatic upload
    setSelectedFile(file);
    return false; // Prevent the default upload behavior
  };

  const fetchDepartments = async () => {
    try {
      const response = await fetch("/api/portal/pms/get_pms_departments"); // Replace with your API URL
      const data = await response.json();
      setDepartments(data); // Save the departments from the API response
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  const fetchAssignees = async () => {
    try {
      const response = await fetch("/api/portal/pms/get_all_pms_Assignees"); // Replace with your API URL
      const data = await response.json();
      if (data.serviceResult) {
        setAssignees(data.serviceResult);
      }
    } catch (error) {
      console.error("Error fetching assignees:", error);
    }
  };

  const getFileNameFromUrl = (fileUrl) => {
    let url = fileUrl;
    if (typeof fileUrl === "object" && fileUrl !== null) {
      url = fileUrl.url || fileUrl.path || "";
    }

    if (typeof url === "string") {
      return url.split("/").pop();
    } else {
      console.error("Invalid URL:", url);
      return "Unknown file";
    }
  };

  const downloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = getFileNameFromUrl(url);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAdditionalInfoChange = (value) => {
    setAdditionalInfo(value);
  };

  const handleReload = async () => {
    await fetchData(currentPage);
    await fetchDataPagination(currentPage);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };
  const handleClearSearch = () => {
    setSearchText("");
    setShowSearchInput(false);
  };

  const filteredDatasearch = searchText
    ? filteredData.filter((record) => {
        const recordString = JSON.stringify(record).toLowerCase();
        return recordString.includes(searchText.toLowerCase());
      })
    : filteredData;

  const regionOptions = [
    { value: 1, label: "Andhra Pradesh" },
    { value: 2, label: "Telangana" },
  ];

  const pageSize = 10;

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await fetch("/api/portal/pms/get_pms_teams_roles");
        const data = await response.json();
        setRoles(data.serviceResult);
      } catch (error) {
        console.error("Failed to fetch roles:", error);
      }
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    fetchDataPagination(currentPage);
  }, [currentPage]);

  const fetchDataPagination = async (page) => {
    try {
      setLoading(true);

      const resultsOffset = (page - 1) * pageSize;

      const requestData = {
        rules: filterApplied ? currentRules : [],
        "results-offset": resultsOffset,
      };

      const response = await fetch(`${Databyquery}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }

      const result = await response.json();

      setFilteredData(result.serviceResult.results);
      setTotalResults(result.serviceResult.totalResults);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkUpload = async () => {
    if (!selectedFile) {
      message.error("Please select an Excel file before uploading!");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetch("/api/portal/pms/bulk_upload_pms", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        message.success("Bulk users uploaded successfully!");
        setShowBulkModal(false);
        setSelectedFile(null);
        fetchData();
      } else {
        const errorResponse = await response.json();
        message.error(
          errorResponse.message || "Failed to upload bulk users. Try again."
        );
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      message.error("Error occurred during file upload.");
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // const fetchDepartments = async () => {
  //   try {
  //     const response = await fetch("/api/portal/pms/get_pms_departments");
  //     if (response.ok) {
  //       const data = await response.json();
  //       setDepartments(
  //         data.serviceResult.map((dept) => ({
  //           value: dept.name,
  //           label: dept.name,
  //         }))
  //       );
  //     } else {
  //       console.error("Failed to fetch departments");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching departments:", error);
  //   }
  // };

  const deletesource = async (rowData) => {
    try {
      const response = await fetch(
        `/api/portal/pms/delete_pms_source/${rowData.seq_id}`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        message.success("Source deleted successfully");
      } else {
        message.error("Failed to delete source");
      }
    } catch (error) {
      message.error("Error deleting source");
      console.error("Error:", error);
    }
  };

  const deltecategory = async (rowData) => {
    try {
      const response = await fetch(
        `/api/portal/pms/delete_pms_categories/${rowData.id}`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        message.success("Source deleted successfully");
      } else {
        message.error("Failed to delete source");
      }
    } catch (error) {
      message.error("Error deleting source");
      console.error("Error:", error);
    }
  };

  const delteassigne = async (rowData) => {
    try {
      const response = await fetch(
        `/api/portal/pms/delete_pms_assignee/${rowData.seq_id}`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        message.success("Source deleted successfully");
      } else {
        message.error("Failed to delete source");
      }
    } catch (error) {
      message.error("Error deleting source");
      console.error("Error:", error);
    }
  };

  const delteFormField = async (rowData) => {
    try {
      const response = await fetch(
        `/api/portal/pms/delete_pms_item/${rowData.seq_id}`,

        {
          method: "GET",
        }
      );

      if (response.ok) {
        message.success("Source deleted successfully");
      } else {
        message.error("Failed to delete source");
      }
    } catch (error) {
      message.error("Error deleting source");
      console.error("Error:", error);
    }
  };

  const editsource = (rowData, index) => {
    sourcedetails.resetFields();
    setEditedDatasource({ ...rowData });

    setUpdateSourceModal(true);
  };
  const onCancelsource = () => {
    setEditedDatasource(null);
    setUpdateSourceModal(false);
    sourcedetails.resetFields();
  };

  useEffect(() => {
    if (editedDatasource !== null) {
      sourcedetails.setFieldsValue({
        name: editedDatasource.name,
      });
    } else {
      sourcedetails.resetFields();
    }
  }, [editedDatasource, sourcedetails]);

  const handlesourceEditSubmit = () => {
    sourcedetails.validateFields().then((values) => {
      const dataToSend = {
        name: values.name,
      };
      console.log("values", values);

      fetch(`/api/portal/pms/update_pms_source/${editedDatasource.seq_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Response:", data);

          message.success(data.message);
          setUpdateSourceModal(false);
          handleReload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  };

  // category
  const editcategory = (rowData, index) => {
    categorydetails.resetFields();
    setEditedDatacategory({ ...rowData });

    setUpdateCategoryModal(true);
  };
  const onCancelcategory = () => {
    setEditedDatacategory(null);
    setUpdateCategoryModal(false);
    categorydetails.resetFields();
  };

  useEffect(() => {
    if (editedDatacategory !== null) {
      categorydetails.setFieldsValue({
        name: editedDatacategory.name,
      });
    } else {
      categorydetails.resetFields();
    }
  }, [editedDatacategory, categorydetails]);

  const handleCategoryEditSubmit = () => {
    categorydetails.validateFields().then((values) => {
      const dataToSend = {
        name: values.name,
      };
      console.log("values", values);

      fetch(`/api/portal/pms/update_pms_categories/${editedDatacategory.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Response:", data);

          message.success(data.message);
          setUpdateCategoryModal(false);
          handleReload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  };

  // Assigne

  const editassigne = (rowData, index) => {
    assigndetails.resetFields();
    setEditedDataassign({ ...rowData });

    setUpdateAssignModal(true);
  };
  const onCancelassigne = () => {
    setEditedDataassign(null);
    setUpdateAssignModal(false);
    assigndetails.resetFields();
  };

  useEffect(() => {
    // fetchDepartments();
    if (editedDataassign !== null) {
      assigndetails.setFieldsValue({
        name: editedDataassign.name,
      });
    } else {
      assigndetails.resetFields();
    }
  }, [editedDataassign, assigndetails]);

  const handleAssigneEditSubmit = () => {
    assigndetails.validateFields().then((values) => {
      const dataToSend = {
        name: values.name,
      };
      console.log("values", values);

      fetch(`/api/portal/pms/update_pms_assignee/${editedDataassign.seq_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Response:", data);

          message.success(data.message);
          setUpdateAssignModal(false);
          handleReload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  };

  // PetitionManagement actions

  const editpetition = async (record) => {
    console.log("record", record.seq_id);
    const seqId = record["seq_id"];
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_details_by_id?id=${seqId}`
      );
      if (response.ok) {
        const data = await response.json();
        const serviceResult = data.serviceResult;

        console.log("Service Result:", serviceResult);

        form.setFieldsValue({
          name: serviceResult.name,
          mobile: serviceResult.mobile,
          issueLocation: serviceResult.address,
          department: serviceResult.department,
          subject: serviceResult.subject,
          state: getStateName(serviceResult),
          constituency: serviceResult.constituency_name,
          district: serviceResult.district_name,
          mandal: serviceResult.mandal_name,
          village: serviceResult.village,
          remarks: serviceResult.remarks,
          assignee: serviceResult.attache,
          UpdateStatus: serviceResult.pms_status,
        });

        const files = (
          Array.isArray(serviceResult.files)
            ? serviceResult.files
            : [serviceResult.files]
        ).map((fileUrl, index) => ({
          uid: index,
          name:
            typeof fileUrl === "string"
              ? fileUrl
              : getFileNameFromUrl(fileUrl.url),
          status: "done",
          url: typeof fileUrl === "object" ? fileUrl.url : fileUrl,
        }));

        console.log("Files to be set in Upload:", files);

        setFileList(files);

        setCurrentId(serviceResult.seq_id);
        setViewRecord(serviceResult);
        setEditModalVisible(true);
      } else {
        message.error("Failed to fetch record details");
      }
    } catch (error) {
      message.error("Error fetching record details");
    }
  };

  const editpetitionstatus = async (record) => {
    const seqId = record["seq_id"];
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_details_by_id?id=${seqId}`
      );
      if (response.ok) {
        const data = await response.json();
        const serviceResult = data.serviceResult;

        setCurrentId(serviceResult.seq_id);
        setViewRecord(serviceResult);
        setEditstatusModalVisible(true);
      } else {
        message.error("Failed to fetch record details");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error fetching record details");
    }
  };

  const fetchRecordDetails = async (recordId) => {
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_details_by_id?id=${recordId}`
      );
      if (response.ok) {
        const data = await response.json();
        setViewRecord(data.serviceResult);
        fetchNotes(recordId);
      } else {
        message.error("Failed to fetch record details");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error fetching record details");
    }
  };

  const fetchNotes = async (recordId) => {
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_team_notes?id=${recordId}`
      );
      if (response.ok) {
        const data = await response.json();
        setNotes(data.serviceResult.notes);
      } else {
        message.error("Failed to fetch notes");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error fetching notes");
    }
  };

  const handleNoteUpdate = async (note, index) => {
    const payload = {
      id: currentRecordId,
      note: {
        text: note.text,
        category: selectedCategory,
        category_value: selectedValue,
      },
    };

    try {
      const response = await fetch(`/api/portal/pms/add_pms_note`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        message.success("Note added successfully");

        setEditedNotes({});

        fetchNotes(currentRecordId);
      } else {
        message.error("Failed to add note");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error adding note");
    }
  };

  const viewpetition = (record) => {
    console.log("view petition", record);
    const seqId = record["seq_id"];
    fetchRecordDetails(seqId);
    setCurrentRecordId(seqId);
    setViewModalVisible(true);
  };

  const closeViewModal = () => {
    setViewRecord(null);
    setViewModalVisible(false);
  };

  const deltepetition = (record) => {
    const seqId = record["seq_id"];
    confirm({
      title: "Are you sure you want to delete this record?",
      icon: <ExclamationCircleOutlined />,
      content: "This action cannot be undone",
      onOk() {
        handleDelete(seqId);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleDelete = async (recordId) => {
    try {
      const response = await fetch(
        `/api/portal/pms/delete_pms_details_by_id?id=${recordId}`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        message.success("Record deleted successfully");
        setFilteredData([]);
        await fetchData(currentPage);
      } else {
        message.error("Failed to delete record");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error deleting record");
    }
  };

  const printpetition = (record) => {
    const seqId = record["seq_id"];

    fetchRecordDetails(seqId);
    setPrintModalVisible(true);
  };

  const printAcknowledgement = async (record) => {
    const seqId = record["seq_id"];
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_details_by_id?id=${seqId}`
      );
      if (!response.ok) {
        message.error("Failed to fetch acknowledgement details");
        return;
      }

      const data = await response.json();
      const serviceResult = data.serviceResult || {};

      setAcknowledgmentData({
        seq_id: serviceResult.seq_id || seqId,
        date: serviceResult.registration_date || serviceResult.createdttm || "",
        name: serviceResult.name || "N/A",
        mobile: serviceResult.mobile || "N/A",
        petitioner_address:
          serviceResult.ptnr_address || serviceResult.address || "N/A",
        department: serviceResult.department || "N/A",
        title: serviceResult.subject || serviceResult.title || "N/A",
      });
      setAcknowledgmentModalVisible(true);
    } catch (error) {
      console.error("Error fetching acknowledgement:", error);
      message.error("Error fetching acknowledgement details");
    }
  };

  const closePrintModal = () => {
    setViewRecord(null);
    setPrintModalVisible(false);
  };

  const handlePrint = () => {
    const printContent = document.getElementById("print-content");
    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <html>
      <head>
        <title>Print Petition</title>
        <style>
          @media print {
            .print-container {
              width: 100%;
              margin: 0 auto;
              padding: 20px;
              box-sizing: border-box;
              font-family: Arial, sans-serif;
            }
            .heading {
              text-align: center;
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            .content-container {
              margin-bottom: 20px;
            }
            .row {
              display: flex;
              margin-bottom: 10px;
            }
            .label {
              width: 200px;
              font-weight: bold;
            }
            .content {
              flex: 1;
            }
            .footer {
              margin-top: 20px;
              text-align: center;
              font-style: italic;
              font-size: 14px;
            }
            @page {
              size: A4;
              margin: 20mm;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <div class="heading">Acknowledgement</div>
          <div class="content-container">
            <div class="row">
              <div class="label">No. :</div>
              <div class="content">${viewRecord.ack_id}</div>
              <div class="label" style="margin-left: 50px;">Date :</div>
              <div class="content">${new Date(
                viewRecord.createdttm
              ).toLocaleDateString("en-GB")}</div>
            </div>
            <div class="row">
              <div class="label">Petitioner Name :</div>
              <div class="content">${viewRecord.name}</div>
            </div>
            <div class="row">
              <div class="label">Phone :</div>
              <div class="content">${viewRecord.mobile}</div>
            </div>
            <div class="row">
              <div class="label">Petitioner Address :</div>
              <div class="content">${viewRecord.ptnr_address}</div>
            </div>
            <div class="row">
              <div class="label">Department :</div>
              <div class="content">${viewRecord.department || "N/A"}</div>
            </div>
            <div class="row">
              <div class="label">Subject :</div>
              <div class="content">${viewRecord.subject}</div>
            </div>
            <div class="row">
              <div class="label">Constituency :</div>
              <div class="content">${viewRecord.constituency_name}</div>
            </div>
            <div class="row">
              <div class="label">District :</div>
              <div class="content">${viewRecord.district_name}</div>
            </div>
            <div class="row">
              <div class="label">Mandal :</div>
              <div class="content">${viewRecord.mandal_name}</div>
            </div>
            <div class="row">
              <div class="label">Village :</div>
              <div class="content">${viewRecord.village}</div>
            </div>
            <div class="row">
              <div class="label">Remarks :</div>
              <div class="content">${viewRecord.remarks || "N/A"}</div>
            </div>
            <div class="row">
              <div class="label">Status :</div>
              <div class="content">${viewRecord.pms_status}</div>
            </div>
            <div class="row">
              <div class="label">Created By :</div>
              <div class="content">${viewRecord.created_by}</div>
            </div>
            <div class="row">
              <div class="label">Updated By :</div>
              <div class="content">${viewRecord.updated_by || "N/A"}</div>
            </div>
          </div>
          <div class="footer">
            This is a computer generated acknowledgement and does not require a signature.
          </div>
        </div>
      </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleEditSubmit = async (values) => {
    const { subject, assignee, issueLocation } = values;
    console.log("viewrecord", viewRecord);
    const seqId = viewRecord["seq_id"];
    const updatedValues = {
      id: seqId,
      subject,
      remarks: viewRecord?.remarks ?? "",
      attache: assignee,
      department: viewRecord?.department,
      address: issueLocation ?? viewRecord?.address ?? "",
      files: fileList.map((file) => {
        if (file.originFileObj) {
          return file.originFileObj;
        }
        return { url: file.url };
      }),
    };

    console.log("Form values:", updatedValues);

    try {
      const response = await fetch("/api/portal/pms/update_pms_details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedValues),
      });

      if (response.ok) {
        fetchData();
        message.success("Petition updated successfully");
        setEditModalVisible(false);
      } else {
        message.error("Failed to update petition");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error updating petition");
    }
  };

  const DownloadFiles = async (recordId) => {
    const seqId = recordId["seq_id"];
    try {
      const response = await fetch(`/api/portal/pms/download_files/${seqId}`, {
        method: "GET",
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `record_${seqId}`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        message.success("Record downloaded successfully");
        // setFilteredData([]);
        // handleReload();
      } else {
        message.error("Failed to download record");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error downloading record");
    }
  };

  const handleEditCancel = () => {
    setEditModalVisible(false);
    form.resetFields();
  };

  const handleEditStateChange = () => {};
  const handleEditDistrictChange = () => {};
  const handleEditConstituencyChange = () => {};

  const handleEditstatusCancel = () => {
    setEditstatusModalVisible(false);
    form.resetFields();
    setStatusModalValueOptions([]);
  };

  // const handleUpdateStatusSubmit = async (values) => {
  //   try {
  //     console.log(values);

  //     const payload = {
  //       id: viewRecord.seq_id,
  //       pms_status: updateStatus,
  //     };

  //     // if (updateStatus === "yes") {
  //     //   payload.political_dividend = values.PoliticalDividend;
  //     // }

  //     // if (updateStatus === "no") {
  //     //   payload.cause = values.cause;
  //     //   payload.explanation = values.explanation;
  //     //   payload.remarks = values.remarks;
  //     // }

  //     const response = await fetch("/api/portal/pms/update_pms_status", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (response.ok) {
  //       message.success("Status updated successfully");
  //       fetchData();
  //       setEditstatusModalVisible(false);
  //       form.resetFields();
  //     } else {
  //       message.error("Failed to update status");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     message.error("Error updating status");
  //   }
  // };

  const handleUpdateStatusSubmit = async (values) => {
    try {
      const seqId = viewRecord?.seq_id;
      if (!seqId) {
        message.error("Missing petition record");
        return;
      }

      const category = values.statusUpdateCategory;
      const categoryValue = values.statusUpdateCategoryValue;
      const notesText = (values.statusUpdateNotes || "").trim();

      if (!notesText) {
        message.error("Please enter notes");
        return;
      }
      if (category !== "remarks" && !categoryValue) {
        message.error("Please select a category value");
        return;
      }

      if (category === "status") {
        const response = await fetch("/api/portal/pms/update_pms_status", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: seqId, status: categoryValue }),
        });

        if (!response.ok) {
          message.error("Failed to update status");
          return;
        }
        message.success("Status updated successfully");
      }

      const messageType =
        values.statusUpdatePublic === true ? "public" : "private";

      const note = {
        text: notesText,
        category,
        messageType,
      };
      if (category !== "remarks" && categoryValue) {
        note.category_value = categoryValue;
      }

      const noteResponse = await fetch("/api/portal/pms/add_pms_note", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: seqId, note }),
      });

      if (!noteResponse.ok) {
        message.error("Failed to add note");
        return;
      }

      message.success("Updated successfully");
      fetchData(currentPage);
      setEditstatusModalVisible(false);
      form.resetFields();
      setStatusModalValueOptions([]);
    } catch (error) {
      console.error("Error:", error);
      message.error("Error updating status and notes");
    }
  };

  const customUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("pms_file", file);

    try {
      const uploadResponse = await fetch("/api/portal/pms/upload_pms_files", {
        method: "POST",
        body: formData,
      });

      if (uploadResponse.ok) {
        const uploadData = await uploadResponse.json();
        const newFile = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: uploadData.serviceResult.url,
        };

        setFileList((prevFileList) => {
          const updatedFileList = [...prevFileList, newFile];

          const payload = {
            id: currentId,
            files: updatedFileList.map((file) => file.url),
          };

          setTimeout(() => {
            fetch("/api/portal/pms/update_pms_files", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            })
              .then((response) => {
                if (response.ok) {
                  onSuccess(uploadData);
                } else {
                  onError(new Error("Update failed"));
                }
              })
              .catch((error) => {
                console.error("Error:", error);
                onError(error);
              });
          }, 2000);

          return updatedFileList;
        });
      } else {
        onError(new Error("Upload failed"));
      }
    } catch (error) {
      console.error("Error:", error);
      onError(error);
    }
  };

  const renderMenu = (record) => {
    const menu = (
      <Menu>
        {addsource && (
          <Menu.Item key="editsource" onClick={() => editsource(record)}>
            Edit
          </Menu.Item>
        )}
        {addsource && (
          <Menu.Item key="deltesource">
            <Popconfirm
              title="Are you sure to delete this source?"
              onConfirm={() => deletesource(record)}
              okText="Yes"
              cancelText="No"
            >
              Delete
            </Popconfirm>
          </Menu.Item>
        )}
        {additem && (
          <>
            <Menu.Item
              key="showEditModal"
              onClick={() => showEditModal(record)}
            >
              Edit
            </Menu.Item>
            <Menu.Item key="delteFormField">
              <Popconfirm
                title="Are you sure to delete this FormField?"
                onConfirm={() => delteFormField(record)}
                okText="Yes"
                cancelText="No"
              >
                Delete
              </Popconfirm>
            </Menu.Item>
          </>
        )}

        {addcategory && (
          <Menu.Item key="editcategory" onClick={() => editcategory(record)}>
            Edit
          </Menu.Item>
        )}
        {addcategory && (
          <Menu.Item key="deltecategory">
            <Popconfirm
              title="Are you sure to delete this category?"
              onConfirm={() => deltecategory(record)}
              okText="Yes"
              cancelText="No"
            >
              Delete
            </Popconfirm>
          </Menu.Item>
        )}

        {addassigne && (
          <Menu.Item key="editassigne" onClick={() => editassigne(record)}>
            Edit
          </Menu.Item>
        )}
        {addassigne && (
          <Menu.Item key="delteassigne">
            <Popconfirm
              title="Are you sure to delete this Assigne?"
              onConfirm={() => delteassigne(record)}
              okText="Yes"
              cancelText="No"
            >
              Delete
            </Popconfirm>
          </Menu.Item>
        )}
        {petitionmanagementactions && (
          <>
            <Menu.Item key="viewpetition" onClick={() => viewpetition(record)}>
              View
            </Menu.Item>
            <Menu.Item key="editpetition" onClick={() => editpetition(record)}>
              Edit
            </Menu.Item>
            {(userRole === "PAT" ||
              userRole === "AD" ||
              userRole === "PCS") && (
              <Menu.Item
                key="deltepetition"
                onClick={() => deltepetition(record)}
              >
                Delete
              </Menu.Item>
            )}
            <Menu.Item
              key="editpetitionstatus"
              onClick={() => editpetitionstatus(record)}
            >
              Update Status/Notes
            </Menu.Item>
            <Menu.Item
              key="printpetition"
              onClick={() => printpetition(record)}
            >
              Print Petition
            </Menu.Item>
            <Menu.Item
              key="printAcknowledgement"
              onClick={() => printAcknowledgement(record)}
            >
              Print Acknowledgement
            </Menu.Item>
            <Menu.Item
              key="downloadfiles"
              onClick={() => DownloadFiles(record)}
            >
              Download Petition
            </Menu.Item>
          </>
        )}
      </Menu>
    );

    return (
      <Popover
        content={menu}
        trigger="click"
        className={questionsModal == true ? "ant-popover" : ""}
      >
        <Button icon={<MoreOutlined />} />
      </Popover>
    );
  };

  const fetchFieldsAndOperators = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${Rulesdata}`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "GET",
      });
      if (!response.ok) {
        console.log("hi");
      }
      const data = await response.json();
      const fetchedFields = data.data.filtets.map((filter) => filter.name);
      setFields(fetchedFields);
      const fetchedFieldsMetadata = data.data.filtets;
      setFieldsMetadata(fetchedFieldsMetadata);

      const fetchedFieldOperators = {};
      data.data.filtets.forEach((filter) => {
        fetchedFieldOperators[filter.name] = filter.operators;
      });
      setFieldOperators(fetchedFieldOperators);

      setRules([
        { id: "", field: "", operator: "", value: "", secondValue: "" },
      ]);
    } catch (error) {
      console.error("Error fetching fields and operators:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchColumns = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${Headername}`);
      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      const data = await response.json();
      // const columnMetadata = data.data.metadata;
      const pmsVisibleFields = new Set([
        "district_name",
        "constituency_name",
        "mandal_name",
        "seq_id",
        "ack_id",
        "name",
        "mobile",
        "village",
        "pms_status",
        "age",
        "petitioner_type",
        "petition_type",
        "solution_type",
        "representation",
        "legalities",
        "priority",
        "severity",
        "registration_date",
        "category",
      ]);
      const isPmsTableMetadata =
        typeof Headername === "string" &&
        Headername.includes("get_pms_table_metadata");

      const columnMappings = data.data.metadata
        .filter((column) => {
          if (column.field === "user_mod_hash") {
            return false;
          }
          if (isPmsTableMetadata) {
            return pmsVisibleFields.has(column.field);
          }
          return true;
        })
        .map((column) => ({
          field: column.field,
          headerName: column.headerName,
        }));

      console.log("Fetched columns:", columnMappings);
      setColumns(columnMappings);

      fetchData();
    } catch (error) {
      console.error("Error fetching columns:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (page) => {
    try {
      setLoading(true);
      const requestBody = {
        rules: rules,
        page: page,
      };

      const response = await fetch(`${Databyquery}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
      setModalVisible(false);

      const data = await response.json();
      const results = data.serviceResult.results;

      const filteredResults = results.map((item) => {
        const filteredItem = {};
        columns.forEach((col) => {
          filteredItem[col.headerName] = item[col.field] || "N/A";
        });
        return filteredItem;
      });

      console.log("Mapped data:", filteredResults);
      setFilteredData(filteredResults);

      // setFilteredData(results);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchColumns();
  }, []);

  useEffect(() => {
    if (columns.length > 0) {
      fetchData();
    }
  }, [columns]);

  const handleExport = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Exporting data:", values);

        const requestData = {
          report_name: values.report_name,
          description: values.description,
          report_id: id,
          rules: rules,
        };

        fetch("/api/portal/reports/exportReport", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("API Response:", data);
            message.success(data.data.message);

            setModalVisible(false);
            handleReload();
          })
          .catch((error) => {
            console.error("API Error:", error);
          });
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const exportExcel = async () => {
    try {
      let requestBody;
      if (filterApplied) {
        requestBody = {
          rules: rules,
        };
      } else {
        requestBody = {};
      }

      // Make the POST request to your API
      const response = await fetch("/api/portal/reports/export_pms_Report", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error("Failed to export Excel");
      }

      const data = await response.json(); // Assuming the response is in JSON format

      if (data.data.status === "1") {
        message.success(
          data.data.message || "Export data will be sent to your Email shortly"
        );
      } else {
        message.error(data.data.message || "Failed to export Excel");
      }
    } catch (error) {
      message.error(`Error: ${error.message}`);
    }
  };

  const setDefaultRules = () => {
    console.log("Resetting filters...");
    setRules([{}]);
    // setRules([{ id: 0, field: "", operator: "", value: "", secondValue: "" }]);
    setFilterApplied(false);
    setCurrentPage(1);

    fetchData();

    console.log("Filters reset and fetchData called.");
  };

  const addRule = () => {
    setRules((prevRules) => [
      ...prevRules,
      {
        id: prevRules.length + 1,
        field: "",
        operator: "",
        value: "",
        secondValue: "",
      },
    ]);
  };

  const removeRule = (ruleId) => {
    if (rules.length == 1) {
      setRules([{ id: "", field: "", operator: "", value: "" }]);
    } else {
      setRules((prevRules) => prevRules.filter((rule) => rule.id !== ruleId));
    }
  };

  const handleFieldChange = (ruleId, selectedField) => {
    const selectedOperators = fieldOperators[selectedField] || [];
    const initialOperator =
      selectedOperators.length > 0 ? selectedOperators[0] : "";

    setRules((prevRules) =>
      prevRules.map((rule) =>
        rule.id === ruleId
          ? {
              ...rule,
              field: selectedField,
              operator: initialOperator,
              value: "",
              secondValue: "",
            }
          : rule
      )
    );
  };

  const handleOperatorChange = (ruleId, selectedOperator) => {
    setRules((prevRules) =>
      prevRules.map((rule) =>
        rule.id === ruleId
          ? { ...rule, operator: selectedOperator, secondValue: "" }
          : rule
      )
    );
  };

  const handleValueChange = (ruleId, newValue) => {
    setRules((prevRules) =>
      prevRules.map((rule) =>
        rule.id === ruleId ? { ...rule, value: newValue } : rule
      )
    );
  };

  const handleSecondValueChange = (ruleId, newSecondValue) => {
    setRules((prevRules) =>
      prevRules.map((rule) =>
        rule.id === ruleId ? { ...rule, secondValue: newSecondValue } : rule
      )
    );
  };
  const toggleFilterSection = () => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
    fetchFieldsAndOperators();
  };

  const handleRegionChange = (value) => {
    setSelectedRegion(value);
  };

  const [selectedConstituency, setSelectedConstituency] = useState(null);

  const handleConstituencySelect = (value) => {
    setSelectedConstituency(value);
  };

  const allConstituencies = Object.values(jsonconst)
    .flat()
    .map((constituency) => constituency.constituency_name);

  const handledistrictsSelect = (value) => {
    setDistrict(value);
  };

  const allDistricts = Object.values(jsondata)
    .flat()
    .map((district) => district.district_name);

  const parliamentConstituencyOptions = jsonpar.map((item) => (
    <Select.Option
      key={item.parliament_constituency_name}
      value={item.parliament_constituency_name}
    >
      {item.parliament_constituency_name}
    </Select.Option>
  ));
  const renderValueInput = (rule) => {
    const fieldMetadata = fieldsMetadata.find(
      (meta) => meta.name === rule.field
    );
    if (!fieldMetadata) {
      return null;
    }
    const fieldType = fieldMetadata.type;
    const operator = rule.operator;
    const fieldname = fieldMetadata.name;

    if (fieldname === "state_name") {
      return (
        <Select
          value={selectedRegion}
          onChange={(value) => handleValueChange(rule.id, value)}
          placeholder="Select Region"
        >
          {regionOptions.map((region) => (
            <Option key={region.value} value={region.value}>
              {region.label}
            </Option>
          ))}
        </Select>
      );
    } else if (fieldname === "district_name") {
      return (
        <Select
          value={district}
          showSearch
          onChange={(value) => handleValueChange(rule.id, value)}
          style={{ width: 200 }}
          placeholder="Select a district"
          optionFilterProp="children"
          onSelect={handledistrictsSelect}
        >
          {allDistricts.map((districtName) => (
            <Option key={districtName} value={districtName}>
              {districtName}
            </Option>
          ))}
        </Select>
      );
    } else if (fieldname == "constituency_name") {
      return (
        <Select
          value={selectedConstituency}
          showSearch
          style={{ width: 200 }}
          onChange={(value) => handleValueChange(rule.id, value)}
          placeholder="Select a constituency"
          optionFilterProp="children"
          onSelect={handleConstituencySelect}
        >
          {allConstituencies.map((constituencyName) => (
            <Option key={constituencyName} value={constituencyName}>
              {constituencyName}
            </Option>
          ))}
        </Select>
      );
    } else if (fieldname == "parliament_constituency_name") {
      return (
        <Select
          showSearch
          onChange={(value) => handleValueChange(rule.id, value)}
          style={{ width: 200 }}
          placeholder="Select a Parliamnet"
          optionFilterProp="children"
        >
          {parliamentConstituencyOptions}
        </Select>
      );
    }

    if (fieldType === "string" || fieldType === "number") {
      if (operator === "between") {
        return (
          <>
            <Input
              value={rule.value}
              onChange={(e) => handleValueChange(rule.id, e.target.value)}
              style={{ width: "15%" }}
            />
            <Input
              value={rule.secondValue}
              onChange={(e) => handleSecondValueChange(rule.id, e.target.value)}
              style={{ width: "15%" }}
            />
          </>
        );
      } else {
        return (
          <Input
            value={rule.value}
            onChange={(e) => handleValueChange(rule.id, e.target.value)}
            style={{ width: "20%" }}
          />
        );
      }
    } else if (fieldType === "number") {
      if (operator === "between") {
        return (
          <>
            <Input
              value={rule.value}
              onChange={(e) => handleValueChange(rule.id, e.target.value)}
              style={{ width: "40%" }}
            />
            <Input
              value={rule.secondValue}
              onChange={(e) => handleSecondValueChange(rule.id, e.target.value)}
              style={{ width: "40%" }}
            />
          </>
        );
      } else {
        return (
          <Input
            value={rule.value}
            onChange={(e) => handleValueChange(rule.id, e.target.value)}
            style={{ width: "20%" }}
          />
        );
      }
    } else if (fieldType === "date") {
      if (operator === "between") {
        return (
          <>
            <DatePicker
              selected={rule.value}
              onChange={(date) => handleValueChange(rule.id, date)}
            />
            <DatePicker
              selected={rule.secondValue}
              onChange={(date) => handleSecondValueChange(rule.id, date)}
            />
          </>
        );
      } else {
        return (
          <DatePicker
            selected={rule.value}
            onChange={(date) => handleValueChange(rule.id, date)}
          />
        );
      }
    }
    return null;
  };

  const handleFilterClick = async () => {
    try {
      setLoading(true);
      const filterRules = rules
        .map((rule) => {
          if (rule.field && rule.operator && rule.value !== "") {
            if (rule.operator === "between" && rule.secondValue !== "") {
              return {
                field: rule.field,
                operator: rule.operator,
                value: [rule.value, rule.secondValue],
              };
            } else {
              return {
                field: rule.field,
                operator: rule.operator,
                value: rule.value,
              };
            }
          }
          return null;
        })
        .filter(Boolean);

      const requestBody = {
        rules: filterRules,
      };

      const response = await fetch(`${Databyquery}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }

      const data = await response.json();
      const filteredResults = data.serviceResult.results;

      const mappedResults = filteredResults.map((item) => {
        const mappedItem = {};
        columns.forEach((col) => {
          mappedItem[col.headerName] = item[col.field] || "N/A";
        });
        return mappedItem;
      });

      setFilteredData(mappedResults);
      setTotalResults(data.serviceResult.totalResults);
      // setFilteredData(filteredResults);
      setFilterApplied(true);
      setCurrentRules(filterRules);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const deleteRowData = (rowData) => {
  //   const updatedData = filteredData.filter((item) => item.id !== rowData.id);
  //   setFilteredData(updatedData);
  // };

  // useEffect(() => {
  //   if (editedDatasource !== null) {
  //     sourcedetails.setFieldsValue({
  //       name: editedDatasource.name,

  //     });
  //   } else {
  //     sourcedetails.resetFields();
  //   }
  // }, [editedDatasource, sourcedetails]);

  const openEditModal = (rowData, index) => {
    questionDashboardForm.resetFields();

    setEditedData({ ...rowData });
    setEditedIndex(index);
    setEditModalVisible(true);
  };

  const resetpassword = async (record) => {
    try {
      setLoading(true);

      const confirmDelete = await new Promise((resolve) => {
        Modal.confirm({
          title: "Reset Password",
          content: "Are you sure you want to resetpassword?",
          onOk() {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          },
        });
      });
      if (!confirmDelete) {
        return;
      }

      const response = await fetch(`/api/portal/volunteers/resetPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: record.id }),
      })
        .then((response) => response.json())
        .then((data) => {
          message.success(data.serviceResult.message);
          handleReload();
        });

      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error toggling status:", error);
    } finally {
      setLoading(false);
    }
  };

  const tableColumns = columns.map((column) => ({
    title: column.headerName,
    dataIndex: column.headerName,
    key: column.field,
    render:
      column.field === "representation"
        ? (value) => {
            const content = value || "N/A";
            return (
              <Tooltip title={content}>
                <span
                  style={{
                    display: "inline-block",
                    maxWidth: 220,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    verticalAlign: "bottom",
                  }}
                >
                  {content}
                </span>
              </Tooltip>
            );
          }
        : undefined,
  }));

  return (
    <div className="container">
      {columns.length > 0 && (
        <div className="filtered-data">
          <h2
            style={{
              paddingLeft: 10,
              textAlign: "inherit",
              backgroundColor: "#01013f",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              height: 50,
            }}
          >
            {title}
            <div style={{ display: "flex", alignItems: "center" }}>
              {showSearchInput ? (
                <Input.Search
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onSearch={handleSearch}
                  style={{ width: 200, marginRight: 50 }}
                  enterButton
                  suffix={<CloseCircleOutlined onClick={handleClearSearch} />}
                />
              ) : (
                <Button
                  style={
                    bulkvolunteers ? { marginRight: 7 } : { marginRight: 6 }
                  }
                  icon={<SearchOutlined />}
                  onClick={() => setShowSearchInput(true)}
                />
              )}

              <Button
                onClick={toggleFilterSection}
                icon={showFilter ? <CloseOutlined /> : <FilterOutlined />}
                style={bulkvolunteers ? { marginRight: 7 } : { marginRight: 5 }}
              />
              <Button
                className="admin"
                icon={<ReloadOutlined />}
                onClick={handleReload}
                style={bulkvolunteers ? { marginRight: 7 } : { marginRight: 5 }}
              />

              {updateadmin && (
                <Button
                  variant="primary"
                  onClick={adminbutton}
                  className="adduserbutton"
                >
                  Add User
                </Button>
              )}

              {addPetitionbutton && (
                <Button onClick={addpetition} className="addsurvey">
                  Add Petition
                </Button>
              )}
              {addPetitionbutton && (
                <Button
                  className="userbutton"
                  onClick={() => setShowBulkModal(true)}
                >
                  Bulk Import
                </Button>
              )}
              {addsource && (
                <Button onClick={addsourcepet} className="addsurvey">
                  Add Source
                </Button>
              )}
              {additem && (
                <Button onClick={additembtn} className="additem">
                  Add Form Field
                </Button>
              )}
              {addcategory && (
                <Button onClick={addcategoryepet} className="addsurvey">
                  Add Category
                </Button>
              )}
              {addassigne && (
                <Button onClick={addassigneepet} className="addsurvey">
                  Add Assigne
                </Button>
              )}
            </div>
          </h2>
          <Spin className="custom-spinner" spinning={loading} tip="Loading...">
            <div
              className={`filter-section ${showFilter ? "" : "hide"}`}
              style={{ backgroundColor: "white" }}
            >
              {rules.map((rule) => (
                <div className="rule-container" key={rule.id}>
                  <div className="rule">
                    <Select
                      className="fixed-width-select"
                      value={rule.field}
                      onChange={(value) => handleFieldChange(rule.id, value)}
                    >
                      <Option value="">Select Field</Option>
                      {fields.map((field) => (
                        <Option key={field} value={field}>
                          {field}
                        </Option>
                      ))}
                    </Select>
                    {rule.field && (
                      <>
                        <Select
                          className="fixed-width-select"
                          value={rule.operator}
                          onChange={(value) =>
                            handleOperatorChange(rule.id, value)
                          }
                        >
                          {fieldOperators[rule.field] &&
                            fieldOperators[rule.field].map((operator) => (
                              <Option key={operator} value={operator}>
                                {operator}
                              </Option>
                            ))}
                        </Select>
                        {renderValueInput(rule)}
                        {/* {rule.operator === "between" && (
                            <Input
                              value={rule.secondValue}
                              style={{ width: "20%" }}
                              onChange={(e) =>
                                handleSecondValueChange(rule.id, e.target.value)
                              }
                            />
                          )} */}
                        <Button onClick={() => removeRule(rule.id)}>
                          <CloseOutlined style={{ paddingTop: -5 }} />
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              ))}
              <div className="buttons" style={{ float: "right" }}>
                <Button type="primary" className="buttonclr" onClick={addRule}>
                  <PlusOutlined />
                  Rule
                </Button>
                <Button
                  type="primary"
                  className="buttonclrfilter"
                  onClick={handleFilterClick}
                >
                  Filter
                </Button>
                <Button
                  onClick={setDefaultRules}
                  style={{ backgroundColor: "#17a2b8", color: "white" }}
                >
                  Reset
                </Button>
                {userRole == "AD" && (
                  <Button
                    visible={modalVisible}
                    type="primary"
                    className="buttonclrexcel"
                    onClick={() => {
                      setModalVisible(true);
                      exportExcel();
                    }}
                  >
                    Export Excel
                  </Button>
                )}
              </div>
            </div>
          </Spin>

          <Table
            className="custom-table table-container"
            columns={[
              ...tableColumns,

              {
                title: "Actions",
                dataIndex: "actions",
                fixed: "right",
                key: "actions",
                render: (_, record) => renderMenu(record),
              },
            ]}
            dataSource={filteredDatasearch}
            showSizeChanger={false}
            pagination={false}
            rowKey={(record) => record["seq_id"]}
          />

          <div className="pagination-controls">
            <Pagination
              current={currentPage}
              total={totalResults}
              pageSize={pageSize}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>

          <AcknowledgmentModal
            visible={acknowledgmentModalVisible}
            onClose={() => setAcknowledgmentModalVisible(false)}
            acknowledgmentData={acknowledgmentData}
          />

          <div className="records">
            <p style={{ fontSize: 15, fontWeight: 500 }}>
              Current Page: {currentPage} of{" "}
              {Math.ceil(totalResults / pageSize)}
            </p>
            <p style={{ marginLeft: 20, fontSize: 15, fontWeight: 500 }}>
              Total Records: {totalResults}
            </p>
          </div>
        </div>
      )}
      <Modal
        title="Update Source Details"
        open={updatesourcemodal}
        onCancel={onCancelsource}
        onOk={handlesourceEditSubmit}
        width={1000}
        maskClosable={false}
        style={{ left: "6%" }}
      >
        <Form
          form={sourcedetails}
          initialValues={editedDatasource}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
        >
          <Form.Item
            label="User Name"
            name="name"
            rules={[{ required: true, message: "Please enter a name" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Update category Details"
        open={updatecategorymodal}
        onCancel={onCancelcategory}
        onOk={handleCategoryEditSubmit}
        width={1000}
        maskClosable={false}
        style={{ left: "6%" }}
      >
        <Form
          form={categorydetails}
          initialValues={editedDatacategory}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
        >
          <Form.Item
            label="User Name"
            name="name"
            rules={[{ required: true, message: "Please enter a name" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Update assign Details"
        open={updateassignmodal}
        onCancel={onCancelassigne}
        onOk={handleAssigneEditSubmit}
        width={1000}
        maskClosable={false}
        style={{ left: "6%" }}
      >
        <Form
          form={assigndetails}
          initialValues={editedDataassign}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
        >
          <Form.Item
            label="User Name"
            name="name"
            rules={[{ required: true, message: "Please enter a name" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="View Petition"
        open={viewModalVisible}
        onCancel={closeViewModal}
        footer={null}
        bodyStyle={{ padding: "20px" }}
        width={1000}
        maskClosable={false}
        style={{ left: "6%" }}
      >
        <Tabs defaultActiveKey="1">
          {/* Tab 1: Petition Details */}
          <TabPane tab="View Petition" key="1">
            {viewRecord && (
              <Descriptions
                bordered
                column={1}
                labelStyle={{ fontWeight: "bold" }}
              >
                <Descriptions.Item label="Name">
                  {viewRecord.name}
                </Descriptions.Item>
                <Descriptions.Item label="Mobile">
                  {viewRecord.mobile}
                </Descriptions.Item>
                <Descriptions.Item label="Issue Address">
                  {viewRecord.address}
                </Descriptions.Item>
                <Descriptions.Item label="Subject">
                  {viewRecord.subject}
                </Descriptions.Item>
                <Descriptions.Item label="Department">
                  {viewRecord.department}
                </Descriptions.Item>
                <Descriptions.Item label="District Name">
                  {viewRecord.district_name}
                </Descriptions.Item>
                <Descriptions.Item label="Constituency Name">
                  {viewRecord.constituency_name}
                </Descriptions.Item>
                <Descriptions.Item label="Mandal Name">
                  {viewRecord.mandal_name}
                </Descriptions.Item>
                <Descriptions.Item label="Village">
                  {viewRecord.village}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  {viewRecord.pms_status}
                </Descriptions.Item>
                {Array.isArray(viewRecord.files) &&
                  viewRecord.files.length > 0 && (
                    <Descriptions.Item label="Files">
                      {viewRecord.files.map((fileUrl, index) => (
                        <Button
                          key={index}
                          type="link"
                          href={fileUrl}
                          download={getFileNameFromUrl(fileUrl)}
                          onClick={(e) => {
                            e.preventDefault();
                            downloadFile(fileUrl);
                          }}
                        >
                          {getFileNameFromUrl(fileUrl)}
                        </Button>
                      ))}
                    </Descriptions.Item>
                  )}
              </Descriptions>
            )}
          </TabPane>

          {/* Tab 2: Notes */}
          <TabPane tab="Notes" key="2">
            <Card title="Notes Section" style={{ marginBottom: "20px" }}>
              <Row gutter={16}>
                <Col span={12}>
                  <Select
                    placeholder="Select Category"
                    style={{ width: "100%", marginBottom: "10px" }}
                    onChange={handleCategoryChange}
                  >
                    {categoryOptions.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={12}>
                  <Select
                    placeholder="Select Value"
                    style={{ width: "100%", marginBottom: "10px" }}
                    onChange={(value) => setSelectedValue(value)}
                    value={selectedValue}
                    disabled={
                      !selectedCategory || selectedCategory === "select value"
                    }
                  >
                    {valueOptions.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {/* Input Box Section */}

                <div style={{ flex: 1, marginRight: "20px" }}>
                  <Input.TextArea
                    value={editedNotes[0] || ""}
                    onChange={(e) =>
                      setEditedNotes({
                        0: e.target.value,
                      })
                    }
                    rows={6}
                    placeholder="Add or edit a note..."
                  />
                  <Button
                    type="primary"
                    style={{ marginTop: "10px" }}
                    onClick={() =>
                      handleNoteUpdate({ text: editedNotes[0] || "" }, 0)
                    }
                  >
                    {notes.length > 0 ? "Add Note" : "Add Note"}
                  </Button>
                </div>

                {/* Notes Display Section */}
                <div
                  style={{
                    flex: 1,
                    maxHeight: "300px", // Set a fixed height for the scrollable section
                    overflowY: "auto", // Enable vertical scrolling
                    border: "1px solid #f0f0f0",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  {notes.length > 0 ? (
                    notes.map((note, index) => (
                      <div key={index} style={{ marginBottom: "15px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>
                            <strong>Added by:</strong> {note.added_by}
                          </p>
                          <p>
                            <strong>Date:</strong>{" "}
                            {moment(note.createdon).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )}
                          </p>
                        </div>
                        {/* <p>
                          <strong>Category:</strong> {note.category || "N/A"}
                        </p> */}
                        <strong>
                          {note.category} :{" "}
                          <Tag color="#cd201f"> {note.category_value}</Tag>
                        </strong>
                        {/* <p>
                          <strong>Category Value:</strong>{" "}
                          {note.category_value || "N/A"}
                        </p> */}
                        <p>
                          <strong>Note:</strong> {note.text}
                        </p>
                        <hr />
                      </div>
                    ))
                  ) : (
                    <p>No notes available</p>
                  )}
                </div>
              </div>
            </Card>
          </TabPane>
        </Tabs>
      </Modal>

      <Modal
        open={printModalVisible}
        onCancel={closePrintModal}
        width={1000}
        style={{ left: "6%" }}
        maskClosable={false}
        footer={[
          <Button key="print" type="primary" onClick={handlePrint}>
            Print Petition
          </Button>,
          <Button key="cancel" onClick={closePrintModal}>
            Close
          </Button>,
        ]}
        bodyStyle={{ padding: "20px" }}
      >
        {viewRecord && (
          <div id="print-content" className="print-container">
            <div className="heading">Print Petition</div>
            <div className="content-container">
              <div className="row">
                <div className="label">No. :</div>
                <div className="content">{viewRecord.ack_id}</div>
                <div className="label" style={{ marginLeft: "20px" }}>
                  Date :
                </div>
                <div className="content">
                  {new Date(viewRecord.createdttm)
                    .toLocaleDateString("en-US", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })
                    .replace(/,/g, "-")
                    .replace(/\s/g, "-")}
                </div>
              </div>
              <div className="row">
                <div className="label">Petitioner Name :</div>
                <div className="content">{viewRecord.name}</div>
              </div>
              <div className="row">
                <div className="label">Phone :</div>
                <div className="content">{viewRecord.mobile}</div>
              </div>
              <div className="row">
                <div className="label">Petitioner Address :</div>
                <div className="content">{viewRecord.ptnr_address}</div>
              </div>
              <div className="row">
                <div className="label">Department :</div>
                <div className="content">{viewRecord.department || "N/A"}</div>
              </div>
              <div className="row">
                <div className="label">Subject :</div>
                <div className="content">{viewRecord.subject}</div>
              </div>
              <div className="row">
                <div className="label">Constituency :</div>
                <div className="content">{viewRecord.constituency_name}</div>
              </div>
              <div className="row">
                <div className="label">District :</div>
                <div className="content">{viewRecord.district_name}</div>
              </div>
              <div className="row">
                <div className="label">Mandal :</div>
                <div className="content">{viewRecord.mandal_name}</div>
              </div>
              <div className="row">
                <div className="label">Village :</div>
                <div className="content">{viewRecord.village}</div>
              </div>
              <div className="row">
                <div className="label">Remarks :</div>
                <div className="content">{viewRecord.remarks || "N/A"}</div>
              </div>
              <div className="row">
                <div className="label">Status :</div>
                <div className="content">{viewRecord.pms_status}</div>
              </div>
              <div className="row">
                <div className="label">Created By :</div>
                <div className="content">{viewRecord.created_by}</div>
              </div>
              <div className="row">
                <div className="label">Updated By :</div>
                <div className="content">{viewRecord.updated_by || "N/A"}</div>
              </div>
            </div>
            <div className="footer">
              This is a computer-generated petition and does not require a
              signature.
            </div>
          </div>
        )}
      </Modal>

      <Modal
        visible={editModalVisible}
        onCancel={handleEditCancel}
        width={1000}
        style={{ left: "6%" }}
        maskClosable={false}
        footer={[
          <Button key="cancel" onClick={handleEditCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => form.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical" onFinish={handleEditSubmit}>
          <h2 style={{ fontSize: "24px", marginBottom: "20px" }}>
            Edit Petition
          </h2>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Petitioner Name</span>
                }
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please enter the petitioner name",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>
                    Petitioner Phone Number
                  </span>
                }
                name="mobile"
                rules={[
                  {
                    required: true,
                    message: "Please enter the petitioner phone number",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Issue Location</span>
                }
                name="issueLocation"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Petition Subject</span>
                }
                name="subject"
                rules={[
                  {
                    required: true,
                    message: "Please enter the petition subject",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>State</span>}
                name="state"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>District</span>}
                name="district"
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Constituency</span>}
                name="constituency"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Mandal</span>}
                name="mandal"
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Village</span>}
                name="village"
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Attache</span>}
                name="assignee"
                rules={[
                  {
                    required: true,
                    message: "Please select an assignee",
                  },
                ]}
              >
                <Select placeholder="Select an assignee">
                  {assignees.map((assignee) => (
                    <Option key={assignee.seq_id} value={assignee.user_name}>
                      {assignee.first_name} {assignee.last_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="files"
                label={
                  <span style={{ fontWeight: "bold" }}>
                    Upload Files (jpeg, jpg, png, pdf)
                  </span>
                }
              >
                <Upload
                  multiple
                  listType="picture"
                  beforeUpload={(file) => {
                    const isAllowedType =
                      file.type === "image/png" ||
                      file.type === "image/jpeg" ||
                      file.type === "image/jpg" ||
                      file.type === "application/pdf";

                    if (!isAllowedType) {
                      message.error(
                        "You can only upload PNG, JPG, JPEG, or PDF files!"
                      );
                    }
                    return isAllowedType || Upload.LIST_IGNORE;
                  }}
                  accept=".png,.jpg,.jpeg,.pdf"
                  customRequest={customUpload}
                  fileList={fileList}
                  onRemove={(file) => {
                    setFileList((prevFileList) =>
                      prevFileList.filter((f) => f.uid !== file.uid)
                    );
                  }}
                >
                  <Button icon={<UploadOutlined />}>Select Files</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title="Upload Bulk Users"
        open={showBulkModal}
        onCancel={() => setShowBulkModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowBulkModal(false)}>
            Close
          </Button>,
          <Button key="upload" onClick={handleBulkUpload}>
            Upload
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="Upload Excel File">
            <Upload
              beforeUpload={beforeUploadFile}
              accept=".xlsx, .xls"
              showUploadList={false} // Disable the default file list
            >
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
            {selectedFile && (
              <div style={{ marginTop: "10px" }}>
                <strong>Selected File:</strong> {selectedFile.name}
              </div>
            )}
            <div className="error">{errors.bulkUpload}</div>
          </Form.Item>
          <div>
            <a
              href="https://janasenabackup.blob.core.windows.net/banners/sample_pms.xlsx"
              download
            >
              Download Sample Excel File
            </a>
          </div>
        </Form>
      </Modal>

      {/* eidtpetitionstatus */}
      <Modal
        title="Update Petition Status"
        visible={editstatusModalVisible}
        onCancel={handleEditstatusCancel}
        width={1000}
        style={{ left: "6%" }}
        maskClosable={false}
        footer={[
          <Button key="cancel" onClick={handleEditstatusCancel}>
            Cancel
          </Button>,
          <Button
            key="updateStatus"
            type="primary"
            onClick={() => form.submit()}
          >
            Update
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical" onFinish={handleUpdateStatusSubmit}>
          <Row gutter={16} align="bottom">
            <Col span={8}>
              <Form.Item
                name="statusUpdateCategory"
                label="Update Category"
                rules={[
                  { required: true, message: "Please select update category" },
                ]}
              >
                <Select
                  placeholder="Select Category"
                  onChange={(value) => {
                    form.setFieldsValue({ statusUpdateCategoryValue: undefined });
                    if (value && value !== "remarks") {
                      fetchStatusModalValueOptions(value);
                    } else {
                      setStatusModalValueOptions([]);
                    }
                  }}
                >
                  {STATUS_MODAL_CATEGORY_OPTIONS.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                noStyle
                shouldUpdate={(prev, cur) =>
                  prev.statusUpdateCategory !== cur.statusUpdateCategory
                }
              >
                {({ getFieldValue }) => {
                  const cat = getFieldValue("statusUpdateCategory");
                  if (cat === "remarks") {
                    return <div style={{ minHeight: 72 }} aria-hidden="true" />;
                  }
                  return (
                    <Form.Item
                      name="statusUpdateCategoryValue"
                      label="Category Value"
                      rules={[
                        {
                          required: !!cat && cat !== "remarks",
                          message: "Please select a value",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select Value"
                        allowClear
                        disabled={!cat}
                      >
                        {statusModalValueOptions.map((option) => (
                          <Option key={option.value} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="statusUpdatePublic"
                valuePropName="checked"
                label="Message Type"
                style={{ marginBottom: 0 }}
              >
                <Checkbox>Message Type (Public)</Checkbox>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                name="statusUpdateNotes"
                label="Notes"
                rules={[{ required: true, message: "Please enter notes" }]}
              >
                <TextArea
                  placeholder="Add or edit a note..."
                  rows={6}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title="Edit Item"
        visible={isModalVisibleForm}
        onCancel={() => setIsModalVisibleForm(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter the name" }]}
              >
                <Input placeholder="Enter name" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default QueryBuilder;
